import { Routes } from '@angular/router';

import { canActivatePlatformRoute } from 'app/platform/auth';

export const routes: Routes = [
  {
    path: 'platform',
    loadComponent: () => import('./platform/platform-layout/platform-layout.component').then((m) => m.PlatformLayoutComponent),
    children: [
      {
        path: 'login',
        loadComponent: () => import('./platform/auth/login/login.component').then((m) => m.PlatformLoginComponent),
      },
      {
        path: 'auto',
        canActivate: [canActivatePlatformRoute],
        loadChildren: () => import('./platform/auto/auto.routes').then((m) => m.AutoRoutes),
      },
      {
        path: '404',
        loadComponent: () => import('./platform/common/error-pages/page-not-found/page-not-found.component').then((m) => m.PlatformPageNotFoundComponent),
      },
      {
        path: '**',
        redirectTo: '404',
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./home/home-layout/home-layout.component').then((m) => m.HomeLayoutComponent),
    children: [
      { path: '', redirectTo: 'quote', pathMatch: 'full' },
      {
        path: 'start',
        redirectTo: 'quote/start',
        pathMatch: 'prefix',
      },
      {
        path: 'quote',
        loadChildren: () => import('./home/create-quote/routing/create-quote.routes').then((m) => m.QuoteRoutes),
      },
      {
        path: 'landing',
        loadComponent: () => import('./home/create-quote/entry/click-leads/landing.component').then((m) => m.LandingComponent),
      },
      {
        path: 'begin',
        loadComponent: () => import('./home/create-quote/entry/begin/begin.component').then((m) => m.BeginComponent),
      },
      {
        path: 'resume',
        loadComponent: () => import('./home/create-quote/entry/resume/resume/resume.component').then((m) => m.ResumeComponent),
      },
      {
        path: 'resume-email-sent',
        loadComponent: () => import('./home/create-quote/entry/resume/resume-email-sent/resume-email-sent.component').then((m) => m.ResumeEmailSentComponent),
      },
      {
        path: 'resume-my-quote/:id',
        loadComponent: () => import('./home/create-quote/entry/resume/resume-my-quote/resume-my-quote.component').then((m) => m.ResumeMyQuoteComponent),
      },
      {
        path: 'resume-my-quote',
        loadComponent: () => import('./home/create-quote/entry/resume/resume-my-quote/resume-my-quote.component').then((m) => m.ResumeMyQuoteComponent),
      },
      {
        path: 'resume-expired-token',
        loadComponent: () => import('./home/create-quote/entry/resume/resume-expired-token/resume-expired-token.component').then((m) => m.ResumeExpiredTokenComponent),
      },
      {
        path: 'thanks',
        loadChildren: () => import('./home/create-quote/routing/ejection.routes').then((m) => m.EjectionRoutes),
      },
      {
        path: '404',
        loadComponent: () => import('./shared/error-pages/page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent),
      },
      {
        path: '**',
        loadComponent: () => import('./shared/error-pages/page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent),
      },
    ],
  },
];
